<template>
  <div>
    <!-- PC：结构对齐 internationalTourism（专题 code ↔ 专业 code / 专业表数据） -->
    <div v-if="is_h5 === false" class="major-detail-pc-root">
      <pheader activeIndex="CourseMajorDisplay" />
      <el-scrollbar ref="detailPageScrollbarRef" wrap-style="overflow-x:hidden;">
        <div class="md-html-page-shell ibp-major-content-shell">
        <div class="md-html-breadcrumb" ref="detailBreadcrumbRef">
          <button type="button" class="md-html-breadcrumb__back" @click="goToCatalog">
            <el-icon class="md-html-breadcrumb__ico"><ArrowLeft /></el-icon>
            返回专业目录
          </button>
        </div>
        <div
          class="md-detail-catalog-layout"
          :class="{
            'md-detail-catalog-layout--two': majorDetail && pcNavSections.length,
            'md-detail-catalog-layout--one': !(majorDetail && pcNavSections.length),
          }"
        >
          <div
            v-if="majorDetail && pcNavSections.length"
            ref="detailSidebarColumnRef"
            class="md-detail-sidebar-column"
          >
            <aside
              ref="detailSidebarAsideRef"
              class="md-html-sidebar"
              :style="detailSidebarFixedStyle"
              aria-label="专业内容导航"
            >
            <div class="md-html-sidebar-major">
              <div class="md-html-sidebar-major__icon" aria-hidden="true">{{ majorSidebarInitial() }}</div>
              <div class="md-html-sidebar-major__info">
                <div class="md-html-sidebar-major__label">专业名称</div>
                <div class="md-html-sidebar-major__name">{{ pageTitle }}</div>
              </div>
            </div>
            <nav class="md-html-sidebar-nav" role="tablist">
              <div
                v-for="(sec, idx) in pcNavSections"
                :key="'md-nav-wrap-' + idx"
                class="md-html-nav-stack"
              >
                <button
                  type="button"
                  class="md-html-nav-item"
                  :class="{ 'md-html-nav-item--active': activeMajorSection === idx }"
                  role="tab"
                  :aria-selected="activeMajorSection === idx"
                  @click="setActiveMajorSection(idx)"
                >
                  <span class="md-html-nav-item__num">{{ navNumChinese(idx) }}</span>
                  <span class="md-html-nav-item__label">{{ sec.title }}</span>
                </button>
                <div
                  v-if="sec && sec.kind === 'solutionItem' && solutionAttachSubNavCount(sec) > 1"
                  class="md-html-sub-nav md-html-sub-nav--attach"
                  :class="{ 'md-html-sub-nav--open': activeMajorSection === idx }"
                >
                  <button
                    v-for="(ent, pidx) in solutionAttachEntries(solutionItemForSection(sec))"
                    :key="'att-sub-' + sec.solIndex + '-' + pidx"
                    type="button"
                    class="md-html-sub-nav__item md-html-sub-nav__item--attach"
                    :class="{
                      'md-html-sub-nav__item--active':
                        activeMajorSection === idx && getSolutionAttachTab(sec.solIndex) === pidx,
                    }"
                    :title="solutionAttachSidebarTitle(ent)"
                    @click.stop="selectSolutionAttach(sec.solIndex, pidx, idx)"
                  >
                    <span class="md-html-sub-nav__attach-label">{{ solutionAttachSidebarShortLabel(ent) }}</span>
                  </button>
                </div>
              </div>
              <div
                v-if="hasTopicCourses && coursesSectionIndex >= 0"
                class="md-html-sub-nav"
                :class="{ 'md-html-sub-nav--open': activeMajorSection === coursesSectionIndex }"
              >
                <button
                  v-for="(obj, tidx) in topicInfosWithCourses"
                  :key="'md-sub-' + tidx"
                  type="button"
                  class="md-html-sub-nav__item"
                  :class="{ 'md-html-sub-nav__item--active': activeTopicCourseTab === tidx }"
                  @click.stop="selectCourseSubTab(tidx)"
                >
                  {{ obj.dict_name }}
                </button>
              </div>
            </nav>
          </aside>
          </div>

          <div class="md-html-main" :style="detailMainMinStyle" v-loading="loading">
            <div v-if="majorDetail && pcNavSections.length" class="md-html-content-area">
              <div class="md-html-inner">
              <div
                v-for="(section, sidx) in pcNavSections"
                v-show="activeMajorSection === sidx"
                :key="'md-panel-' + sidx"
                class="md-html-section-panel"
              >
                <template v-if="section.kind === 'intro'">
                  <div class="md-html-section-head">
                    <h1 class="md-html-section-title">{{ section.title }}</h1>
                  </div>
                  <div class="md-html-card">
                    <div class="major-ztjs-html" v-html="majorDetail.zhuantijieshaoItems[section.zidx].value"></div>
                  </div>
                </template>
                <template v-else-if="section.kind === 'solutionItem'">
                  <template
                    v-for="wrap in [{ sol: solutionItemForSection(section), k: section.solIndex }]"
                    :key="'sol-pc-' + wrap.k"
                  >
                    <div v-if="wrap.sol">
                      <div class="md-html-section-head">
                        <h1 class="md-html-section-title">{{ section.title }}</h1>
                        <p v-if="solutionHasAttach(wrap.sol)" class="md-html-section-desc">
                          {{ solutionAttachSectionDesc(wrap.sol, wrap.k) }}
                        </p>
                      </div>
                      <!-- 与「专业课程体系」下 search-page .page-content 一致：平铺 + 10px 内边距，不用 major-solution-row 白卡片 -->
                      <div class="md-solution-panel">
                        <template v-if="solutionHasAttach(wrap.sol)">
                          <template v-if="solutionAttachDisplayKind(activeSolutionWrap(wrap).attach) === 'image'">
                            <div class="md-solution-pdf-viewer">
                              <div
                                class="md-solution-pdf-viewer__toolbar"
                                :class="{
                                  'md-solution-pdf-viewer__toolbar--noFilename':
                                    solutionAttachEntries(wrap.sol).length <= 1,
                                }"
                              >
                                <span
                                  v-if="solutionAttachEntries(wrap.sol).length > 1"
                                  class="md-solution-pdf-viewer__label"
                                  :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                                >
                                  {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                                </span>
                                <a
                                  class="md-solution-pdf-viewer__open"
                                  :href="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  新窗口打开
                                </a>
                              </div>
                              <div class="md-solution-pdf-viewer__stage md-solution-pdf-viewer__stage--embed">
                                <div class="md-solution-embed md-solution-embed--image">
                                  <img
                                    :src="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                                    :alt="section.title"
                                    class="md-solution-embed__img"
                                  />
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-else-if="solutionAttachDisplayKind(activeSolutionWrap(wrap).attach) === 'pdf'">
                            <div class="md-solution-pdf-viewer">
                              <div
                                class="md-solution-pdf-viewer__toolbar"
                                :class="{
                                  'md-solution-pdf-viewer__toolbar--noFilename':
                                    solutionAttachEntries(wrap.sol).length <= 1,
                                }"
                              >
                                <span
                                  v-if="solutionAttachEntries(wrap.sol).length > 1"
                                  class="md-solution-pdf-viewer__label"
                                  :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                                >
                                  {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                                </span>
                                <a
                                  class="md-solution-pdf-viewer__open"
                                  :href="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  新窗口打开
                                </a>
                              </div>
                              <div class="md-solution-pdf-viewer__stage">
                                <pdf-js-viewer
                                  :key="solutionPdfIframeSrc(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                                  class="md-solution-pdf-viewer__pdfjs"
                                  :pdf-src="solutionPdfIframeSrc(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                                />
                              </div>
                            </div>
                          </template>
                          <template v-else-if="solutionAttachDisplayKind(activeSolutionWrap(wrap).attach) === 'html'">
                            <div class="md-solution-pdf-viewer md-solution-pdf-viewer--htmlEmbed">
                              <div
                                class="md-solution-pdf-viewer__toolbar"
                                :class="{
                                  'md-solution-pdf-viewer__toolbar--noFilename':
                                    solutionAttachEntries(wrap.sol).length <= 1,
                                }"
                              >
                                <span
                                  v-if="solutionAttachEntries(wrap.sol).length > 1"
                                  class="md-solution-pdf-viewer__label"
                                  :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                                >
                                  {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                                </span>
                                <a
                                  class="md-solution-pdf-viewer__open"
                                  :href="solutionAttachHtmlEmbedSrc(activeSolutionWrap(wrap).attach)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  新窗口打开
                                </a>
                              </div>
                              <div class="md-solution-pdf-viewer__stage md-solution-pdf-viewer__stage--html">
                                <iframe
                                  :key="solutionAttachHtmlIframeKey(activeSolutionWrap(wrap).attach)"
                                  class="md-solution-html-iframe"
                                  :src="solutionAttachHtmlEmbedSrc(activeSolutionWrap(wrap).attach)"
                                  :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                                  sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox allow-downloads"
                                />
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="md-solution-pdf-viewer md-solution-pdf-viewer--linkOnly">
                              <div class="md-solution-pdf-viewer__toolbar">
                                <span
                                  class="md-solution-pdf-viewer__label"
                                  :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                                >
                                  {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                                </span>
                                <a
                                  class="md-solution-pdf-viewer__open"
                                  :href="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  新窗口打开
                                </a>
                              </div>
                            </div>
                          </template>
                        </template>
                        <div
                          v-if="ztjsItemHasContent({ value: wrap.sol.content })"
                          class="major-ztjs-html md-solution-panel__html"
                          v-html="wrap.sol.content"
                        />
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else-if="section.kind === 'courses'">
                  <div class="md-html-section-head">
                    <h1 class="md-html-section-title">{{ section.title }}</h1>
                    <p class="md-html-section-desc">
                      本专业课程体系分为基础、核心、拓展三个层次，由浅入深构建完整的知识与技能框架。
                    </p>
                  </div>
                  <div class="md-course-tabs" role="tablist" aria-label="课程分类">
                    <button
                      v-for="(obj, idx) in topicInfosWithCourses"
                      :key="'md-ctab-' + idx"
                      type="button"
                      class="md-course-tab"
                      :class="{ 'md-course-tab--active': activeTopicCourseTab === idx }"
                      role="tab"
                      :aria-selected="activeTopicCourseTab === idx"
                      @click="setTopicCourseTab(idx)"
                    >
                      {{ obj.dict_name }}
                    </button>
                  </div>
                  <div class="md-course-tab-panel major-topic-tab-panel" role="tabpanel">
                    <search-page
                      v-if="currentTopicWithCourses"
                      :searchParam="currentTopicSearchParam"
                      :get_search_page_data="majorFieldCoursesApi"
                      span-basis="container"
                    />
                  </div>
                </template>
              </div>
              </div>
            </div>
            <el-empty
              v-else-if="majorDetail && !pcNavSections.length && !loading"
              description="暂无展示内容"
              class="md-html-empty"
            />
            <el-empty
              v-else-if="!majorDetail && !loading"
              description="未找到该专业"
              class="md-html-empty"
            />
          </div>
        </div>
        </div>
        <pfooter></pfooter>
      </el-scrollbar>
    </div>

    <!-- H5：保留独立详情，版式简化 -->
    <div v-else class="major-detail-h5">
      <pheader activeIndex="CourseMajorDisplay" />
      <div class="h5-topbar">
        <button type="button" class="h5-back" @click="goToCatalog">
          <van-icon name="arrow-left" />
          <span>专业目录</span>
        </button>
      </div>
      <div v-if="bannerImages.length" class="h5-carousel-wrap">
        <van-swipe class="h5-swipe" :autoplay="3000" indicator-color="#175cc4">
          <van-swipe-item v-for="(bImg, idx) in bannerImages" :key="idx">
            <van-image width="100%" height="180" fit="cover" :src="bImg" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="h5-title-block">
        <h1 class="h5-page-title">{{ pageTitle }}</h1>
        <p v-if="majorDetail" class="h5-page-meta">
          {{ majorDetail.college || '—' }}
        </p>
      </div>
      <div v-loading="loading" class="h5-detail-body">
        <div
          v-if="majorDetail && pcNavSections.length"
          class="h5-md-segment"
          role="tablist"
          aria-label="专业内容"
        >
          <button
            v-for="(sec, idx) in pcNavSections"
            :key="'h5-seg-' + idx"
            type="button"
            class="h5-md-segment__btn"
            :class="{ 'h5-md-segment__btn--active': activeMajorSection === idx }"
            role="tab"
            :aria-selected="activeMajorSection === idx"
            @click="setActiveMajorSection(idx)"
          >
            {{ sec.title }}
          </button>
        </div>
        <template v-if="majorDetail && pcNavSections.length">
          <div
            v-for="(section, sidx) in pcNavSections"
            v-show="activeMajorSection === sidx"
            :key="'h5-panel-' + sidx"
            class="h5-md-panel"
          >
            <template v-if="section.kind === 'intro'">
              <div class="h5-md-panel__head">
                <span class="h5-md-panel__tag">专题介绍</span>
                <h2 class="h5-md-panel__title">{{ section.title }}</h2>
              </div>
              <div class="h5-md-panel__card">
                <div
                  class="h5-ztjs-html major-ztjs-html"
                  v-html="majorDetail.zhuantijieshaoItems[section.zidx].value"
                />
              </div>
            </template>
            <template v-else-if="section.kind === 'solutionItem'">
              <template
                v-for="wrap in [{ sol: solutionItemForSection(section), k: section.solIndex }]"
                :key="'sol-h5-' + wrap.k"
              >
                <div v-if="wrap.sol">
                  <div class="h5-md-panel__head">
                    <h2 class="h5-md-panel__title h5-md-panel__title--solo">{{ section.title }}</h2>
                    <p
                      v-if="solutionHasAttach(wrap.sol)"
                      class="h5-md-solution-desc"
                    >
                      {{ solutionAttachSectionDesc(wrap.sol, wrap.k) }}
                    </p>
                  </div>
                  <div
                    v-if="solutionAttachEntries(wrap.sol).length > 1"
                    class="h5-md-attach-chips"
                    role="tablist"
                    aria-label="附件切换"
                  >
                    <button
                      v-for="(ent, pidx) in solutionAttachEntries(wrap.sol)"
                      :key="'h5-att-' + wrap.k + '-' + pidx"
                      type="button"
                      class="h5-md-attach-chips__btn"
                      :class="{ 'h5-md-attach-chips__btn--active': getSolutionAttachTab(wrap.k) === pidx }"
                      role="tab"
                      :aria-selected="getSolutionAttachTab(wrap.k) === pidx"
                      :title="solutionAttachFileName(ent.attach, ent.rowShadow)"
                      @click="selectSolutionAttach(wrap.k, pidx, null)"
                    >
                      {{ solutionAttachShortLabel(ent) }}
                    </button>
                  </div>
                  <div class="h5-md-solution-panel">
                    <template v-if="solutionHasAttach(wrap.sol)">
                      <template v-if="solutionAttachDisplayKind(activeSolutionWrap(wrap).attach) === 'image'">
                        <div class="md-solution-pdf-viewer md-solution-pdf-viewer--h5">
                          <div
                            class="md-solution-pdf-viewer__toolbar"
                            :class="{
                              'md-solution-pdf-viewer__toolbar--noFilename':
                                solutionAttachEntries(wrap.sol).length <= 1,
                            }"
                          >
                            <span
                              v-if="solutionAttachEntries(wrap.sol).length > 1"
                              class="md-solution-pdf-viewer__label"
                              :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                            >
                              {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                            </span>
                            <a
                              class="md-solution-pdf-viewer__open"
                              :href="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              新窗口打开
                            </a>
                          </div>
                          <div
                            class="md-solution-pdf-viewer__stage md-solution-pdf-viewer__stage--embed"
                          >
                            <div class="md-solution-embed md-solution-embed--image">
                              <img
                                :src="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                                :alt="section.title"
                                class="md-solution-embed__img"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="solutionAttachDisplayKind(activeSolutionWrap(wrap).attach) === 'pdf'">
                        <div class="md-solution-pdf-viewer md-solution-pdf-viewer--h5">
                          <div
                            class="md-solution-pdf-viewer__toolbar"
                            :class="{
                              'md-solution-pdf-viewer__toolbar--noFilename':
                                solutionAttachEntries(wrap.sol).length <= 1,
                            }"
                          >
                            <span
                              v-if="solutionAttachEntries(wrap.sol).length > 1"
                              class="md-solution-pdf-viewer__label"
                              :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                            >
                              {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                            </span>
                            <a
                              class="md-solution-pdf-viewer__open"
                              :href="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              新窗口打开
                            </a>
                          </div>
                          <div class="md-solution-pdf-viewer__stage">
                            <pdf-js-viewer
                              :key="solutionPdfIframeSrc(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                              class="md-solution-pdf-viewer__pdfjs"
                              :pdf-src="solutionPdfIframeSrc(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                            />
                          </div>
                        </div>
                      </template>
                      <template v-else-if="solutionAttachDisplayKind(activeSolutionWrap(wrap).attach) === 'html'">
                        <div class="md-solution-pdf-viewer md-solution-pdf-viewer--h5 md-solution-pdf-viewer--htmlEmbed">
                          <div
                            class="md-solution-pdf-viewer__toolbar"
                            :class="{
                              'md-solution-pdf-viewer__toolbar--noFilename':
                                solutionAttachEntries(wrap.sol).length <= 1,
                            }"
                          >
                            <span
                              v-if="solutionAttachEntries(wrap.sol).length > 1"
                              class="md-solution-pdf-viewer__label"
                              :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                            >
                              {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                            </span>
                            <a
                              class="md-solution-pdf-viewer__open"
                              :href="solutionAttachHtmlEmbedSrc(activeSolutionWrap(wrap).attach)"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              新窗口打开
                            </a>
                          </div>
                          <div class="md-solution-pdf-viewer__stage md-solution-pdf-viewer__stage--html">
                            <iframe
                              :key="solutionAttachHtmlIframeKey(activeSolutionWrap(wrap).attach)"
                              class="md-solution-html-iframe"
                              :src="solutionAttachHtmlEmbedSrc(activeSolutionWrap(wrap).attach)"
                              :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                              sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox allow-downloads"
                            />
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="md-solution-pdf-viewer md-solution-pdf-viewer--h5 md-solution-pdf-viewer--linkOnly"
                        >
                          <div class="md-solution-pdf-viewer__toolbar">
                            <span
                              class="md-solution-pdf-viewer__label"
                              :title="solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow)"
                            >
                              {{ solutionAttachFileName(activeSolutionWrap(wrap).attach, activeSolutionWrap(wrap).rowShadow) }}
                            </span>
                            <a
                              class="md-solution-pdf-viewer__open"
                              :href="solutionAttachUrl(activeSolutionWrap(wrap).attach, { inlinePreview: true })"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              新窗口打开
                            </a>
                          </div>
                        </div>
                      </template>
                    </template>
                    <div
                      v-if="ztjsItemHasContent({ value: wrap.sol.content })"
                      class="h5-ztjs-html major-ztjs-html h5-md-solution-panel__html"
                      v-html="wrap.sol.content"
                    />
                  </div>
                </div>
              </template>
            </template>
            <template v-else-if="section.kind === 'courses'">
              <div class="h5-md-panel__head">
                <span class="h5-md-panel__tag">课程资源</span>
                <h2 class="h5-md-panel__title">{{ section.title }}</h2>
              </div>
              <div class="md-course-tabs md-course-tabs--h5" role="tablist" aria-label="课程分类">
                <button
                  v-for="(obj, idx) in topicInfosWithCourses"
                  :key="'h5-ctab-' + idx"
                  type="button"
                  class="md-course-tab"
                  :class="{ 'md-course-tab--active': activeTopicCourseTab === idx }"
                  role="tab"
                  :aria-selected="activeTopicCourseTab === idx"
                  @click="setTopicCourseTab(idx)"
                >
                  {{ obj.dict_name }}
                </button>
              </div>
              <div class="md-course-tab-panel major-topic-tab-panel major-topic-tab-panel--h5" role="tabpanel">
                <search-page
                  v-if="currentTopicWithCourses"
                  :searchParam="currentTopicSearchParam"
                  :get_search_page_data="majorFieldCoursesApi"
                  :is_h5="true"
                />
              </div>
            </template>
          </div>
        </template>
        <van-empty v-else-if="!loading" description="未找到该专业" />
      </div>
      <pfooter></pfooter>
    </div>

    <ai-search-component :isisShow="isisShow"></ai-search-component>
    <div
      class="ibp-h5-ai-fab"
      role="button"
      tabindex="0"
      aria-label="打开课程助手"
      @click="clickAIButton($event)"
      @keydown.enter.prevent="clickAIButton($event)"
    >
      <div class="ibp-h5-ai-fab__inner">
        <el-image class="ibp-h5-ai-fab__img" fit="contain" :src="require('@/assets/hcvt.png')" />
        <p class="ibp-h5-ai-fab__label">课程助手</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ArrowLeft } from '@element-plus/icons-vue'
import { showNotify } from 'vant'
import { isMajorCatalogLoginOk, isMajorDetailLoginRequired } from '@/common/js/majorCatalogSession'
import pheader from '@/views/pheader.vue'
import pfooter from '@/views/pfooter.vue'
import aiSearchComponent from '@/components/ai-search-component.vue'
import searchPage from '@/components/search-page.vue'
import PdfJsViewer from '@/components/pdf-js-viewer.vue'

export default {
  name: 'CourseMajorDetail',
  components: {
    pheader,
    pfooter,
    aiSearchComponent,
    searchPage,
    PdfJsViewer,
    ArrowLeft,
  },
  data() {
    return {
      is_h5: this.$utils.checkScreenSize(),
      loading: false,
      majorDetail: null,
      isisShow: 0,
      majorFieldCoursesApi: '/courseMajorApp/loadSearchPageDataByMajorField',
      /** 相关课程 topicInfos 当前选中的 tab 下标 */
      activeTopicCourseTab: 0,
      /** 左侧导航 / H5 分段：当前选中的内容块下标（对齐 version/major-detail.html） */
      activeMajorSection: 0,
      /** 培养方案每条 major_solution 下多附件时，当前选中的附件下标（key = solIndex） */
      solutionAttachTabBySol: {},
      /** 宽屏下左侧导航 position:fixed 的内联坐标（与占位列对齐，同专业目录页） */
      detailSidebarFixedStyle: {},
      /** 右侧主栏 min-height 与固定侧栏等高，避免右侧「变矮」不协调 */
      detailMainMinStyle: {},
    }
  },
  computed: {
    pageTitle() {
      const n = this.majorDetail && this.majorDetail.major_name
      return n || '专业详情'
    },
    bannerImages() {
      const m = this.majorDetail
      if (!m) return []
      const base = typeof window !== 'undefined' && window.baseURL ? window.baseURL : ''
      const urls = []
      const al = m.attach_list
      if (al && al.length) {
        al.forEach((row) => {
          const u = row && row.attach
          if (u) urls.push(u)
        })
      }
      const infos = m.file_infos
      if (infos && infos.length) {
        infos.forEach((obj) => {
          if (obj && obj.url) urls.push(obj.url)
        })
      }
      return urls
        .map((u) => {
          if (!u) return ''
          if (String(u).startsWith('http')) return u
          return base + u
        })
        .filter(Boolean)
    },
    /** 仅包含有课程 id 的分类，用于合并为一块「相关课程」 */
    topicInfosWithCourses() {
      const rows = (this.majorDetail && this.majorDetail.topicInfos) || []
      return rows.filter((o) => o.items && o.items.length)
    },
    hasTopicCourses() {
      return this.topicInfosWithCourses.length > 0
    },
    /** 当前 tab 对应的分类（用于单个 search-page，避免多 tab 同时拉数据） */
    currentTopicWithCourses() {
      const list = this.topicInfosWithCourses
      if (!list.length) return null
      let i = this.activeTopicCourseTab | 0
      if (i < 0 || i >= list.length) i = 0
      return list[i]
    },
    /** 稳定引用：仅随当前分类变化，避免父组件重渲染时重复触发 search-page 的 watch */
    currentTopicSearchParam() {
      const obj = this.currentTopicWithCourses
      if (!obj) return {}
      return this.searchParamForTopic(obj)
    },
    /** 培养方案条目：后台 major_solution 列表，含 title / content / attach；每项对应侧栏一级目录 */
    majorSolutionItems() {
      const m = this.majorDetail
      if (!m) return []
      const raw = m.major_solution
      if (!raw || !Array.isArray(raw)) return []
      return raw.filter(
        (row) =>
          row &&
          (String(row.title || '').trim() ||
            String(row.content || '').trim() ||
            String(row.attach || '').trim()),
      )
    },
    /** PC 侧栏与 H5 分段：专题介绍(多条) / 培养方案各条目(一级) / 专业课程体系(置底) */
    pcNavSections() {
      const items = []
      if (!this.majorDetail) return items
      const zt = this.majorDetail.zhuantijieshaoItems || []
      zt.forEach((it, zidx) => {
        if (this.ztjsItemHasContent(it)) {
          items.push({
            kind: 'intro',
            zidx,
            title: (it && it.name) || '专题介绍',
          })
        }
      })
      this.majorSolutionItems.forEach((row, sidx) => {
        items.push({
          kind: 'solutionItem',
          solIndex: sidx,
          title: (row.title && String(row.title).trim()) || '—',
        })
      })
      if (this.hasTopicCourses) {
        items.push({ kind: 'courses', title: '课程体系' })
      }
      return items
    },
    coursesSectionIndex() {
      return this.pcNavSections.findIndex((s) => s.kind === 'courses')
    },
  },
  watch: {
    '$route.params.majorId'() {
      if (!this.ensureMajorDetailAuthOrRedirect()) return
      this.loadDetail()
    },
    topicInfosWithCourses(list) {
      if (list && list.length && this.activeTopicCourseTab >= list.length) {
        this.activeTopicCourseTab = 0
      }
    },
    pcNavSections(list) {
      if (!list || !list.length) {
        this.activeMajorSection = 0
        this.$nextTick(() => {
          this.updateDetailSidebarFixedPosition()
        })
        return
      }
      if (this.activeMajorSection >= list.length) {
        this.activeMajorSection = 0
      }
      this.$nextTick(() => {
        this.updateDetailSidebarFixedPosition()
        this.bindDetailSidebarObserver()
        this.bindDetailScrollbarWrapScroll()
      })
    },
  },
  mounted() {
    window.addEventListener('resize', this.windowResize)
    window.addEventListener('scroll', this.handleWindowScrollForDetailSidebar, { passive: true })
    if (!this.ensureMajorDetailAuthOrRedirect()) return
    this.loadDetail()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.windowResize)
    window.removeEventListener('scroll', this.handleWindowScrollForDetailSidebar)
    this.teardownDetailSidebarLayout()
  },
  methods: {
    /** 需登录且未登录时退回专业目录，避免直链绕过列表上的登录弹窗 */
    ensureMajorDetailAuthOrRedirect() {
      if (!isMajorDetailLoginRequired()) return true
      if (isMajorCatalogLoginOk()) return true
      showNotify({ type: 'warning', message: '请先登录后再查看专业详情' })
      this.$router.replace({ name: 'CourseMajorDisplay' })
      return false
    },
    windowResize() {
      this.is_h5 = this.$utils.checkScreenSize()
      if (this.is_h5) {
        this.teardownDetailSidebarLayout()
      } else {
        this.$nextTick(() => {
          this.updateDetailSidebarFixedPosition()
          this.bindDetailSidebarObserver()
          this.bindDetailScrollbarWrapScroll()
        })
      }
    },
    isDesktopDetailSidebarFixed() {
      return (
        this.is_h5 === false &&
        window.innerWidth > 960 &&
        !!this.majorDetail &&
        this.pcNavSections &&
        this.pcNavSections.length > 0
      )
    },
    getDetailScrollbarWrapEl() {
      const sb = this.$refs.detailPageScrollbarRef
      if (!sb) return null
      const w = sb.wrapRef
      if (w == null) return null
      return typeof w === 'object' && 'value' in w ? w.value : w
    },
    teardownDetailSidebarLayout() {
      if (this._detailScrollRaf != null) {
        cancelAnimationFrame(this._detailScrollRaf)
        this._detailScrollRaf = null
      }
      this.unbindDetailSidebarObserver()
      this.unbindDetailSidebarAsideHeightObserver()
      this.unbindDetailScrollbarWrapScroll()
      this.detailSidebarFixedStyle = {}
      this.detailMainMinStyle = {}
    },
    updateDetailSidebarFixedPosition() {
      if (!this.isDesktopDetailSidebarFixed()) {
        this.detailSidebarFixedStyle = {}
        this.detailMainMinStyle = {}
        this.unbindDetailSidebarObserver()
        this.unbindDetailSidebarAsideHeightObserver()
        this.unbindDetailScrollbarWrapScroll()
        return
      }
      this.$nextTick(() => {
        this.applyDetailSidebarFixedPosition()
      })
    },
    applyDetailSidebarFixedPosition() {
      if (!this.isDesktopDetailSidebarFixed()) {
        this.detailSidebarFixedStyle = {}
        this.detailMainMinStyle = {}
        return
      }
      const col = this.$refs.detailSidebarColumnRef
      if (!col) {
        this.detailSidebarFixedStyle = {}
        this.detailMainMinStyle = {}
        return
      }
      const colRect = col.getBoundingClientRect()
      const w = Math.round(colRect.width) || 220
      const left = Math.max(0, colRect.left)
      const bc = this.$refs.detailBreadcrumbRef
      const bcRect = bc ? bc.getBoundingClientRect() : null
      const vh = window.innerHeight
      const breadcrumbInView = bcRect && bcRect.bottom > 0 && bcRect.top < vh
      let topPx
      if (breadcrumbInView) {
        topPx = Math.max(12, Math.round(colRect.top))
      } else {
        topPx = 16
      }
      const maxH = Math.max(160, Math.round(vh - topPx - 16))
      this.detailSidebarFixedStyle = {
        position: 'fixed',
        left: `${left}px`,
        top: `${topPx}px`,
        width: `${w}px`,
        maxHeight: `${maxH}px`,
        zIndex: '35',
        boxSizing: 'border-box',
        overflow: 'auto',
      }
      this.$nextTick(() => {
        this.syncDetailMainMinHeight()
      })
    },
    syncDetailMainMinHeight() {
      if (!this.isDesktopDetailSidebarFixed()) {
        this.detailMainMinStyle = {}
        return
      }
      const aside = this.$refs.detailSidebarAsideRef
      if (!aside) {
        this.detailMainMinStyle = {}
        return
      }
      const h = Math.round(aside.getBoundingClientRect().height)
      if (h > 0) {
        this.detailMainMinStyle = { minHeight: `${h}px` }
      }
    },
    bindDetailSidebarAsideHeightObserver() {
      this.unbindDetailSidebarAsideHeightObserver()
      if (!this.isDesktopDetailSidebarFixed()) return
      const aside = this.$refs.detailSidebarAsideRef
      if (!aside || typeof ResizeObserver === 'undefined') return
      this._detailAsideHeightObs = new ResizeObserver(() => {
        this.syncDetailMainMinHeight()
      })
      this._detailAsideHeightObs.observe(aside)
    },
    unbindDetailSidebarAsideHeightObserver() {
      if (this._detailAsideHeightObs) {
        this._detailAsideHeightObs.disconnect()
        this._detailAsideHeightObs = null
      }
    },
    handleWindowScrollForDetailSidebar() {
      if (!this.isDesktopDetailSidebarFixed()) return
      if (this._detailScrollRaf != null) return
      this._detailScrollRaf = requestAnimationFrame(() => {
        this._detailScrollRaf = null
        this.applyDetailSidebarFixedPosition()
      })
    },
    bindDetailSidebarObserver() {
      this.unbindDetailSidebarObserver()
      if (!this.isDesktopDetailSidebarFixed()) return
      const el = this.$refs.detailSidebarColumnRef
      if (!el || typeof ResizeObserver === 'undefined') return
      this._detailResizeObs = new ResizeObserver(() => {
        this.applyDetailSidebarFixedPosition()
      })
      this._detailResizeObs.observe(el)
      this.bindDetailSidebarAsideHeightObserver()
    },
    unbindDetailSidebarObserver() {
      if (this._detailResizeObs) {
        this._detailResizeObs.disconnect()
        this._detailResizeObs = null
      }
    },
    bindDetailScrollbarWrapScroll() {
      this.unbindDetailScrollbarWrapScroll()
      if (!this.isDesktopDetailSidebarFixed()) return
      const wrap = this.getDetailScrollbarWrapEl()
      if (!wrap) return
      this._detailScrollbarWrapEl = wrap
      this._detailWrapScrollHandler = () => this.handleWindowScrollForDetailSidebar()
      wrap.addEventListener('scroll', this._detailWrapScrollHandler, { passive: true })
    },
    unbindDetailScrollbarWrapScroll() {
      if (this._detailScrollbarWrapEl && this._detailWrapScrollHandler) {
        this._detailScrollbarWrapEl.removeEventListener('scroll', this._detailWrapScrollHandler)
      }
      this._detailScrollbarWrapEl = null
      this._detailWrapScrollHandler = null
    },
    goToCatalog() {
      this.$router.push({ name: 'CourseMajorDisplay' })
    },
    clickAIButton() {
      this.isisShow += 1
    },
    ztjsItemHasContent(ztjsItem) {
      const v = ztjsItem && ztjsItem.value
      if (v == null) return false
      if (typeof v === 'string') return v.length > 0
      return String(v).length > 0
    },
    /** 与专题页 search-page 入参对齐：code 用专业代码；课程接口仍走 major_id + type_key */
    searchParamForTopic(obj) {
      const m = this.majorDetail
      if (!m) return {}
      return {
        code: m.code || m.major_code,
        major_id: m._id,
        type_key: obj.dict_code,
      }
    },
    setTopicCourseTab(idx) {
      const n = this.topicInfosWithCourses.length
      if (n === 0) return
      const i = Math.max(0, Math.min(Number(idx) || 0, n - 1))
      this.activeTopicCourseTab = i
    },
    setActiveMajorSection(idx) {
      const n = this.pcNavSections.length
      if (n === 0) return
      this.activeMajorSection = Math.max(0, Math.min(Number(idx) || 0, n - 1))
    },
    selectCourseSubTab(tidx) {
      const ci = this.coursesSectionIndex
      if (ci < 0) return
      this.setActiveMajorSection(ci)
      this.setTopicCourseTab(tidx)
    },
    navNumChinese(i) {
      const cn = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      return i < 10 ? cn[i] : String(i + 1)
    },
    majorSidebarInitial() {
      const n = (this.majorDetail && this.majorDetail.major_name) || ''
      const t = String(n).trim()
      if (!t) return '专'
      return t.charAt(0)
    },
    /** 侧栏某项对应的 major_solution 行（与 section.solIndex 对应） */
    solutionItemForSection(section) {
      if (!section || section.kind !== 'solutionItem') return null
      const list = this.majorSolutionItems
      const i = section.solIndex
      if (i == null || i < 0 || i >= list.length) return null
      return list[i]
    },
    /** 侧栏：某培养方案块下可切换的附件条数（用于是否展示子导航） */
    solutionAttachSubNavCount(sec) {
      const row = this.solutionItemForSection(sec)
      return row ? this.solutionAttachEntries(row).length : 0
    },
    /**
     * 一条 major_solution 解析为多条 { attach, rowShadow }（attach 为上传数组；可选 static_html 走 courseMajorApp 静态接口）。
     * 上传附件展示顺序与数组存储顺序相反；指定静态 HTML 固定排在子导航末尾。
     */
    solutionAttachEntries(row) {
      if (!row) return []
      const att = row.attach
      const entries = []
      if (Array.isArray(att) && att.length) {
        const mapped = att
          .map((it) => {
            if (typeof it === 'string') {
              const u = it.trim()
              return u ? { attach: u, nameHint: '' } : null
            }
            const u = it && String(it.url || '').trim()
            if (!u) return null
            const nm = String((it && (it.name || it.comment)) || '').trim()
            const aliasRaw = it && it.alias != null ? String(it.alias) : ''
            const aliasHint = aliasRaw.trim()
            return { attach: u, nameHint: nm, aliasHint }
          })
          .filter(Boolean)
          .map((e) => ({
            attach: e.attach,
            rowShadow: {
              ...row,
              attach: e.attach,
              attach_name: e.nameHint || null,
              attach_alias: e.aliasHint || null,
            },
          }))
        entries.push(...mapped.slice().reverse())
      }
      const staticHtmlItems = []
      const shRaw = row.static_html
      if (Array.isArray(shRaw)) {
        shRaw.forEach((x) => {
          if (x && typeof x === 'object' && !Array.isArray(x)) {
            const rel = String(x.rel || x.path || '').trim()
            if (rel) {
              staticHtmlItems.push({
                rel,
                alias: String(x.alias || '').trim(),
              })
            }
          } else {
            const rel = String(x || '').trim()
            if (rel) staticHtmlItems.push({ rel, alias: '' })
          }
        })
      } else if (shRaw && typeof shRaw === 'object') {
        const rel = String(shRaw.rel || shRaw.path || '').trim()
        if (rel) {
          staticHtmlItems.push({
            rel,
            alias: String(shRaw.alias || '').trim(),
          })
        }
      } else {
        const rel = String(shRaw || '').trim()
        if (rel) staticHtmlItems.push({ rel, alias: '' })
      }
      staticHtmlItems.forEach(({ rel, alias }) => {
        const u = `/courseMajorApp/majorSolutionStaticHtml?rel=${encodeURIComponent(rel)}`
        const baseName = rel.replace(/\\/g, '/').split('/').pop() || rel
        entries.push({
          attach: u,
          rowShadow: {
            ...row,
            attach: u,
            attach_name: baseName,
            attach_alias: alias || null,
          },
        })
      })
      return entries
    },
    getSolutionAttachTab(solIndex) {
      const k = Number(solIndex)
      const v = this.solutionAttachTabBySol[k]
      return v == null ? 0 : v
    },
    selectSolutionAttach(solIndex, attachIdx, sectionNavIdx) {
      const row = this.majorSolutionItems[solIndex]
      const n = row ? this.solutionAttachEntries(row).length : 0
      if (!n) return
      const t = Math.max(0, Math.min(Number(attachIdx) || 0, n - 1))
      this.solutionAttachTabBySol = { ...this.solutionAttachTabBySol, [Number(solIndex)]: t }
      if (sectionNavIdx != null) {
        this.setActiveMajorSection(sectionNavIdx)
      }
    },
    activeSolutionEntry(row, solIndex) {
      const entries = this.solutionAttachEntries(row)
      if (!entries.length) return null
      const t = this.getSolutionAttachTab(solIndex)
      return entries[t] || entries[0]
    },
    /** v-for wrap 上取当前选中附件 */
    activeSolutionWrap(wrap) {
      if (!wrap || !wrap.sol) return { attach: '', rowShadow: wrap && wrap.sol ? wrap.sol : {} }
      const e = this.activeSolutionEntry(wrap.sol, wrap.k)
      if (e) return e
      return { attach: wrap.sol.attach, rowShadow: wrap.sol }
    },
    /** 去掉末尾「.扩展名」仅用于展示；扩展名按 1～5 位字母数字识别，避免误伤「xx.backup」等 */
    _stripFilenameExtensionForDisplay(name) {
      const t = String(name || '').trim()
      if (!t) return t
      const m = t.match(/^(.+)\.([a-z0-9]{1,5})$/i)
      if (!m || !m[1]) return t
      return m[1].trim() || t
    },
    /**
     * 侧栏 / H5 芯片等导航用展示名：有别名时优先别名；否则与 solutionAttachFileName 一致（原始文件名）。
     * PDF 内嵌工具栏、预览 URL 文件名等仍只用 solutionAttachFileName。
     */
    solutionAttachSidebarDisplayName(attach, row) {
      if (row != null && row.attach_alias != null) {
        const a = String(row.attach_alias).trim()
        if (a) return a
      }
      return this.solutionAttachFileName(attach, row)
    },
    /** PC 左侧附件子导航：完整标题（无后缀） */
    solutionAttachSidebarTitle(ent) {
      return this._stripFilenameExtensionForDisplay(
        this.solutionAttachSidebarDisplayName(ent.attach, ent.rowShadow),
      )
    },
    /** PC 左侧附件子导航：截断标签（无后缀） */
    solutionAttachSidebarShortLabel(ent) {
      const s = String(this.solutionAttachSidebarTitle(ent) || '附件').trim()
      if (s.length <= 22) return s
      return `${s.slice(0, 20)}…`
    },
    solutionAttachShortLabel(ent) {
      const full = this.solutionAttachSidebarDisplayName(ent.attach, ent.rowShadow)
      const s = String(full || '附件').trim()
      if (s.length <= 22) return s
      return `${s.slice(0, 20)}…`
    },
    solutionHasAttach(row) {
      return this.solutionAttachEntries(row).length > 0
    },
    /** 路径末段是否为下载接口占位名（真实文件名在 query 里） */
    _attachPathSegmentIsPlaceholder(seg) {
      return /^(downFile|uploadFile|downfile|file)$/i.test(String(seg || '').trim())
    },
    /** 解析 query 参数：保留 + 为加号（避免 3+2 被当成 3 2） */
    _attachQueryDecode(raw) {
      try {
        return decodeURIComponent(String(raw).replace(/\+/g, '%2B')).trim()
      } catch (e) {
        return String(raw).trim()
      }
    },
    /** 从附件串解析 filepath= 物理路径（downFile / preview 共用） */
    _attachFilepathFromAttach(attach) {
      const s = String(attach == null ? '' : attach).trim()
      const m = s.match(/[?&]filepath=([^&#]+)/i)
      if (!m) return ''
      return this._attachQueryDecode(m[1])
    },
    /** 从附件路径或 URL 解析扩展名（小写，不含点）；兼容 /base/downFile?filepath=...&filename=... */
    _attachExtension(attach) {
      const s = String(attach == null ? '' : attach)
        .trim()
        .toLowerCase()
      if (s.includes('majorsolutionstatichtml')) {
        try {
          const qi = s.indexOf('?')
          const q = qi >= 0 ? s.slice(qi + 1) : ''
          const params = new URLSearchParams(q)
          const rel = params.get('rel') || params.get('path') || ''
          if (rel) {
            const decoded = decodeURIComponent(rel)
            const i = decoded.lastIndexOf('.')
            if (i > 0) return decoded.slice(i + 1).toLowerCase()
          }
        } catch (e) {
          /* ignore */
        }
      }
      if (!s) return ''
      const extOf = (name) => {
        const i = name.lastIndexOf('.')
        if (i < 0) return ''
        return name.slice(i + 1)
      }
      let ext = ''
      const fm = s.match(/[?&]filename=([^&#]+)/i)
      if (fm) {
        try {
          ext = extOf(this._attachQueryDecode(fm[1]))
        } catch (e) {
          ext = extOf(fm[1])
        }
      }
      if (!ext) {
        const mfp = s.match(/[?&]filepath=([^&#]+)/i)
        if (mfp) {
          try {
            const fp = this._attachQueryDecode(mfp[1])
            ext = extOf(fp.split(/[/\\]/).pop() || '')
          } catch (e) {
            ext = extOf(mfp[1].split(/[/\\]/).pop() || '')
          }
        }
      }
      if (!ext) {
        const path = s.split('?')[0]
        const seg = path.split('/').pop() || ''
        if (!this._attachPathSegmentIsPlaceholder(seg)) {
          ext = extOf(seg)
        }
      }
      return ext
    },
    /**
     * 原始文件名（不含别名）：优先 attach_name；再 filename=、filepath 的 basename；勿用路径上的 downFile。
     * 用于 PDF 工具栏文案、内嵌预览 URL、iframe title 等。
     */
    solutionAttachFileName(attach, row) {
      if (row != null && row.attach_name != null) {
        const n = String(row.attach_name).trim()
        if (n) return n
      }
      const s = String(attach == null ? '' : attach).trim()
      if (!s) return 'PDF 文档'
      const tryDecode = (raw) => this._attachQueryDecode(raw)
      const mFn = s.match(/[?&]filename=([^&#]+)/i)
      if (mFn) {
        const name = tryDecode(mFn[1])
        if (name) return name
      }
      const mfp = s.match(/[?&]filepath=([^&#]+)/i)
      if (mfp) {
        const fp = tryDecode(mfp[1])
        const base = fp.split(/[/\\]/).filter(Boolean).pop() || ''
        if (base && !this._attachPathSegmentIsPlaceholder(base)) return base
      }
      const mName = s.match(/[?&]name=([^&#]+)/i)
      if (mName) {
        const name = tryDecode(mName[1])
        if (name) return name
      }
      const pathOnly = s.split('?')[0].split('#')[0]
      const last = pathOnly.split('/').filter(Boolean).pop() || ''
      if (last && !this._attachPathSegmentIsPlaceholder(last)) {
        return tryDecode(last)
      }
      return 'PDF 文档'
    },
    /** PDF、常见图片：请求 inline=1，后端 downFile 以 Content-Disposition: inline 返回，便于新窗口预览 */
    _attachSupportsInlinePreview(attach) {
      const ext = this._attachExtension(attach)
      return ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext)
    },
    /** 培养方案附件展示类型：页面内嵌预览用 */
    solutionAttachDisplayKind(attach) {
      const ext = this._attachExtension(attach)
      if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) return 'image'
      if (ext === 'pdf') return 'pdf'
      if (ext === 'html' || ext === 'htm') return 'html'
      return 'other'
    },
    /** HTML 内嵌 iframe 地址（不加 inline=1，由接口 Content-Type 决定） */
    solutionAttachHtmlEmbedSrc(attach) {
      return this.solutionAttachUrl(attach, {})
    },
    solutionAttachHtmlIframeKey(attach) {
      return String(attach == null ? '' : attach).trim() || 'html-embed'
    },
    /** 培养方案区块说明文案（图片/PDF 内嵌与其它附件区分） */
    solutionAttachSectionDesc(row, solIndex) {
      if (!this.solutionHasAttach(row)) return ''
      const e = this.activeSolutionEntry(row, solIndex)
      if (!e) return ''
      const k = this.solutionAttachDisplayKind(e.attach)
      if (k === 'image' || k === 'pdf' || k === 'html') {
        return ''
      }
      return '点击下方链接可查看或下载专业建设相关材料。'
    },
    solutionAttachUrl(attach, opts) {
      const o = opts || {}
      const u = attach == null ? '' : String(attach).trim()
      if (!u) return ''
      let url = u
      if (!u.startsWith('http://') && !u.startsWith('https://')) {
        const base = typeof window !== 'undefined' && window.baseURL ? window.baseURL : ''
        url = base + (u.startsWith('/') ? u : '/' + u)
      }
      if (
        o.inlinePreview &&
        this._attachSupportsInlinePreview(attach) &&
        !/[?&]inline=/.test(url)
      ) {
        url += (url.indexOf('?') >= 0 ? '&' : '?') + 'inline=1'
      }
      return url
    },
    /**
     * 培养方案 PDF 内联预览（iframe / PDF.js 同源地址）。
     * Chrome 内置 PDF 侧栏标题常取 URL 路径最后一段，/base/downFile 会显示为 downFile；
     * 优先使用 /base/preview/展示文件名?filepath=...&inline=1，路径末段即为真实文件名。
     */
    solutionPdfIframeSrc(attach, row) {
      const fp = this._attachFilepathFromAttach(attach)
      let name = String(this.solutionAttachFileName(attach, row) || '').trim()
      if (!name || name === 'PDF 文档') {
        name = 'document.pdf'
      }
      if (this.solutionAttachDisplayKind(attach) === 'pdf' && !/\.pdf$/i.test(name)) {
        name = /\.[a-z0-9]{1,8}$/i.test(name) ? name : `${name}.pdf`
      }
      const safe = name.replace(/[/\\?%*:|"<>]/g, '_') || 'document.pdf'

      if (fp) {
        const base =
          typeof window !== 'undefined' && window.baseURL
            ? String(window.baseURL).replace(/\/$/, '')
            : ''
        const enc = encodeURIComponent(safe)
        return `${base}/base/preview/${enc}?filepath=${encodeURIComponent(fp)}&inline=1`
      }

      const raw = this.solutionAttachUrl(attach, { inlinePreview: true })
      if (!raw) return ''
      try {
        const origin =
          typeof window !== 'undefined' && window.location && window.location.origin
            ? window.location.origin
            : 'http://localhost'
        const u = new URL(raw, origin)
        u.searchParams.set('filename', safe)
        return u.toString()
      } catch (e) {
        const join = raw.indexOf('?') >= 0 ? '&' : '?'
        return `${raw}${join}filename=${encodeURIComponent(safe)}`
      }
    },
    loadDetail() {
      const id = this.$route.params.majorId
      if (!id) {
        showNotify('缺少专业标识')
        return
      }
      this.teardownDetailSidebarLayout()
      this.loading = true
      this.majorDetail = null
      this.$http
        .post('/courseMajorApp/loadCourseMajorDetail', { _id: id })
        .then((res) => {
          this.loading = false
          if (res.resultCode === '0' || res.resultCode === 0) {
            this.majorDetail = res.resultData || null
            this.activeTopicCourseTab = 0
            this.activeMajorSection = 0
            this.solutionAttachTabBySol = {}
            if (!this.majorDetail) {
              showNotify('未获取到专业信息')
            } else {
              const t = this.majorDetail.major_name
                ? `${this.majorDetail.major_name} · 专业详情 - 海职院教学资源平台`
                : '专业详情 - 海职院教学资源平台'
              document.title = t
            }
            this.$nextTick(() => {
              this.updateDetailSidebarFixedPosition()
              this.bindDetailSidebarObserver()
              this.bindDetailScrollbarWrapScroll()
              this.$nextTick(() => {
                this.bindDetailScrollbarWrapScroll()
                this.applyDetailSidebarFixedPosition()
              })
            })
          } else {
            window.vueAlter(res.resultMsg || '加载失败', 'warning')
          }
        })
        .catch(() => {
          this.loading = false
          showNotify('请求失败，请稍后再试')
        })
    },
  },
}
</script>

<style scoped>
/* —— 对齐 app/jxzysjpt/version/major-detail.html 的版式与配色 —— */
.major-detail-pc-root {
  background: #f6f6f6;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 避免父级裁剪 fixed 侧栏（与专业目录页思路一致） */
.major-detail-pc-root :deep(.el-scrollbar__view) {
  overflow-x: hidden;
}

/* 水平宽度由全局 .ibp-major-content-shell 与专业课程目录页共用 */
.md-html-page-shell {
  padding-top: 10px;
  padding-bottom: 8px;
}

.md-html-breadcrumb {
  background: #f7f9fc;
  border-bottom: 1px solid #e0e7f0;
  min-height: 44px;
  display: flex;
  align-items: center;
  padding: 10px 4px 10px 0;
  box-sizing: border-box;
  border-radius: 12px 12px 0 0;
}

.md-html-breadcrumb__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #1456c8;
  cursor: pointer;
  font-family: inherit;
}

.md-html-breadcrumb__back:hover {
  color: #0d3fa0;
}

.md-html-breadcrumb__ico {
  font-size: 16px;
}

.md-html-hero {
  background: #e8eef8;
  max-width: 100%;
}

.md-html-hero__img {
  width: 100%;
  height: 240px;
  display: block;
}

.md-html-hero--fallback {
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 16px;
  background: linear-gradient(180deg, #e8eef8 0%, #f6f6f6 100%);
}

.md-html-hero-fallback__name {
  font-size: 24px;
  font-weight: 800;
  color: #1a1a2e;
  text-align: center;
}

.md-html-hero-fallback__meta {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}

/* Grid：与专业目录 catalog-layout 一致；宽屏下侧栏坐标由脚本 inline 设为 fixed */
.md-detail-catalog-layout {
  display: grid;
  grid-template-columns: minmax(0, 240px) minmax(0, 1fr);
  gap: 20px;
  align-items: stretch;
  min-height: 480px;
  padding-top: 4px;
}

.md-detail-catalog-layout--one {
  grid-template-columns: minmax(0, 1fr);
}

.md-detail-sidebar-column {
  min-width: 0;
  min-height: 0;
  align-self: stretch;
}

.md-html-sidebar {
  width: 100%;
  max-width: 240px;
  box-sizing: border-box;
  background: #2367b0;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
  border-radius: 0 14px 14px 0;
  -webkit-overflow-scrolling: touch;
}

.md-html-sidebar-major {
  margin: 16px 14px 12px;
  padding: 12px 14px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.md-html-sidebar-major__icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  background: linear-gradient(135deg, #1456c8, #3b8beb);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 800;
  color: #fff;
}

.md-html-sidebar-major__label {
  font-size: 10px;
  color: #888;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.md-html-sidebar-major__name {
  font-size: 15px;
  font-weight: 800;
  color: #1456c8;
  line-height: 1.25;
  word-break: break-all;
}

.md-html-sidebar-nav {
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 0 12px;
}

/* 每条侧栏目录 + 其下附件子导航同属一次 v-for，避免子块落在循环外 sec 未定义 */
.md-html-nav-stack {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.md-html-nav-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background 0.2s, border-color 0.2s;
}

.md-html-nav-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.md-html-nav-item--active {
  background: rgba(255, 255, 255, 0.12);
  border-left-color: #5dc8f4;
}

.md-html-nav-item__num {
  width: 22px;
  height: 22px;
  min-width: 22px;
  margin-top: 1px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
}

.md-html-nav-item--active .md-html-nav-item__num {
  background: #5dc8f4;
  color: #1a3a6e;
}

.md-html-nav-item__label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.45;
  font-weight: 500;
}

.md-html-nav-item--active .md-html-nav-item__label {
  color: #fff;
  font-weight: 600;
}

.md-html-sub-nav {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease;
}

.md-html-sub-nav--open {
  max-height: 220px;
}

.md-html-sub-nav--attach.md-html-sub-nav--open {
  max-height: min(380px, 48vh);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.md-html-sub-nav__item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 14px 8px 48px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.68);
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
}

.md-html-sub-nav__item:hover {
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.95);
}

.md-html-sub-nav__item--active {
  color: #5dc8f4;
  font-weight: 600;
}

.md-html-sub-nav__item::before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.75;
  flex-shrink: 0;
}

.md-html-sub-nav__item--attach {
  padding-top: 6px;
  padding-bottom: 6px;
  align-items: flex-start;
}

.md-html-sub-nav__attach-label {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  line-height: 1.4;
  text-align: left;
}

.md-html-sidebar-foot {
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  text-align: center;
}

.md-html-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #f6f6f6;
  border-radius: 14px 0 0 0;
}

/* 与 detailMainMinStyle 配合：内容较少时主栏仍与左侧导航底边对齐 */
.md-html-main > .md-html-content-area {
  flex: 1 1 auto;
  min-height: 100%;
}

/* 主内容区占满 shell 内右侧栏宽度 */
.md-html-content-area {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}

.md-html-inner {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 36px clamp(14px, 2.4vw, 28px) 48px;
  box-sizing: border-box;
}

.md-html-section-panel {
  animation: mdHtmlFadeIn 0.35s ease both;
}

@keyframes mdHtmlFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.md-html-section-head {
  margin-bottom: 22px;
  padding-bottom: 2px;
}

.md-html-section-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #1a3a6e;
  background: #eef4ff;
  border: 1px solid #c5d9f5;
  border-radius: 20px;
  margin-bottom: 10px;
}

.md-html-section-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1.3;
}

.md-html-section-desc {
  margin: 10px 0 0;
  font-size: 14px;
  color: #666;
  line-height: 1.7;
}

/* 对齐专题页白底卡片与课程卡片（xbox）观感 */
.md-html-card {
  background: #fff;
  border: none;
  border-radius: 12px;
  padding: 24px clamp(18px, 2.5vw, 32px) 28px;
  box-shadow: 6px 9px 3px rgb(123 123 123 / 21%);
}

.md-html-card .major-ztjs-html {
  font-size: 18px;
  line-height: 1.75;
  padding: 5px 0;
}

/* 富文本内表格：与专题页、静态稿表格层次一致 */
.md-html-card :deep(table) {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin: 12px 0;
}

.md-html-card :deep(th),
.md-html-card :deep(td) {
  padding: 10px 14px;
  border: 1px solid #e8edf5;
  vertical-align: top;
  line-height: 1.6;
}

.md-html-card :deep(th) {
  background: #f0f5ff;
  color: #1a3a6e;
  font-weight: 600;
  text-align: left;
}

.md-html-card :deep(tr:nth-child(even) td) {
  background: #fafcff;
}

.md-course-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  border-bottom: 2px solid #e5eaf5;
  margin-top: 4px;
  margin-bottom: 24px;
  padding-bottom: 2px;
}

.md-course-tab {
  padding: 10px 20px;
  margin-bottom: -2px;
  font-size: 14px;
  font-weight: 600;
  color: #888;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-family: inherit;
  transition: color 0.2s, border-color 0.2s;
}

.md-course-tab:hover {
  color: #1a3a6e;
}

.md-course-tab--active {
  color: #1a3a6e;
  border-bottom-color: #1e6fd9;
}

.md-course-tab:focus-visible {
  outline: 2px solid #1456c8;
  outline-offset: 2px;
}

.md-course-tab-panel {
  min-height: min(520px, 58vh);
  box-sizing: border-box;
}

/* 培养方案单条：与下方 .page-content 同一套内边距，和「专业课程体系」正文对齐 */
.md-solution-panel {
  padding: 10px;
  overflow-x: hidden;
  box-sizing: border-box;
}

.md-solution-panel .major-solution-attach-link + .md-solution-panel__html,
.md-solution-panel .md-solution-pdf-viewer + .md-solution-panel__html {
  margin-top: 14px;
}

.md-solution-embed {
  margin-bottom: 0;
}

.md-solution-embed--image {
  line-height: 0;
}

.md-solution-embed__img {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.08);
  vertical-align: top;
}

/* PDF：白底 + only light，减轻内置阅读器在暗色系统下整块发黑；路径常为 downFile，标题用 solutionAttachFileName */
.md-solution-pdf-viewer {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e4e9f2;
  background: #ffffff !important;
  color-scheme: only light;
  forced-color-adjust: none;
  box-shadow:
    0 1px 0 rgba(23, 92, 196, 0.05),
    0 10px 28px rgba(15, 40, 80, 0.07);
  margin-bottom: 4px;
}

.md-solution-pdf-viewer__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f4f7fb 100%);
  border-bottom: 1px solid #e8edf5;
}

.md-solution-pdf-viewer__toolbar--noFilename {
  justify-content: flex-end;
}

.md-solution-pdf-viewer__label {
  flex: 1;
  min-width: 0;
  margin-right: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.md-solution-pdf-viewer__open {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #175cc4;
  text-decoration: none;
}

.md-solution-pdf-viewer__open:hover {
  text-decoration: underline;
  color: #0d4a9e;
}

.md-solution-pdf-viewer__stage {
  position: relative;
  background: #ffffff !important;
  color-scheme: only light;
  forced-color-adjust: none;
}

.md-solution-pdf-viewer__stage--embed {
  padding: 10px 14px 14px;
  box-sizing: border-box;
}

.md-solution-pdf-viewer__stage--html {
  padding: 0;
  min-height: min(72vh, 720px);
  overflow: hidden;
}

.md-solution-html-iframe {
  display: block;
  width: 100%;
  height: min(72vh, 720px);
  min-height: min(72vh, 720px);
  border: 0;
  background: #ffffff;
  color-scheme: only light;
}

.md-solution-pdf-viewer--h5 .md-solution-pdf-viewer__stage--html {
  min-height: min(52vh, 460px);
}

.md-solution-pdf-viewer--h5 .md-solution-html-iframe {
  height: min(52vh, 460px);
  min-height: min(52vh, 460px);
}

.md-solution-pdf-viewer--linkOnly .md-solution-pdf-viewer__toolbar {
  border-bottom: none;
}

.md-solution-pdf-viewer__pdfjs {
  width: 100%;
  min-height: min(72vh, 720px);
  display: block;
  background-color: #ffffff !important;
  color-scheme: only light;
  forced-color-adjust: none;
}

@media (prefers-color-scheme: dark) {
  .md-solution-pdf-viewer {
    border-color: #3d4a5c;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  }

  .md-solution-pdf-viewer__toolbar {
    background: linear-gradient(180deg, #ffffff 0%, #eef2f8 100%);
    border-bottom-color: #c5ced9;
  }

  .md-solution-pdf-viewer__label {
    color: #1a1a1a;
  }
}

.md-solution-pdf-viewer--h5 .md-solution-pdf-viewer__pdfjs {
  min-height: min(52vh, 460px);
}

.md-solution-pdf-viewer--h5 .md-solution-pdf-viewer__pdfjs .pdf-js-viewer__iframe {
  min-height: min(52vh, 460px);
}


.h5-md-attach-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 12px 12px;
  box-sizing: border-box;
}

.h5-md-attach-chips__btn {
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(23, 92, 196, 0.22);
  background: #fff;
  color: #175cc4;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.h5-md-attach-chips__btn--active {
  background: #e8f1fc;
  border-color: #175cc4;
  color: #134a9e;
}

.h5-md-solution-desc {
  margin: 8px 0 0;
  font-size: 13px;
  color: #666;
  line-height: 1.55;
}

/* search-page 课程网格：与 internationalTourism / search-page 默认一致 */
.md-course-tab-panel :deep(.page-content) {
  padding: 10px;
  overflow-x: hidden;
}

.md-course-tab-panel :deep(.page-content .row) {
  padding-bottom: 20px;
}

.md-course-tab-panel :deep(.page-content .col) {
  padding-bottom: 20px;
}

.md-course-tab-panel :deep(.page-content .xbox) {
  width: 100%;
  aspect-ratio: 1 / 1;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 6px 9px 3px rgb(123 123 123 / 21%);
}

.md-course-tab-panel :deep(.page-content .xbox:hover) {
  box-shadow: rgba(0, 0, 0, 0.07) 0 0 9px 6px;
}

.md-course-tab-panel :deep(.page-content .xbox .text) {
  padding: 20px 14px;
  font-size: 12px;
  color: #999;
}

.md-course-tab-panel :deep(.page-content .xbox .title) {
  font-size: 16px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.md-course-tab-panel :deep(.page-content .xbox .source) {
  margin: 11px 0 23px;
}

.md-course-tab-panel :deep(.pagination-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

.md-html-empty {
  padding: 48px 24px;
}

@media screen and (max-width: 1100px) {
  .md-detail-catalog-layout {
    gap: 14px;
  }

  .md-html-sidebar-major__info,
  .md-html-sidebar-foot,
  .md-html-nav-item__label,
  .md-html-sub-nav {
    display: none;
  }

  .md-html-nav-item {
    justify-content: center;
    padding: 14px 8px;
  }

  .md-html-sidebar-major {
    justify-content: center;
    margin: 10px 8px;
    padding: 10px;
  }

  .md-html-inner {
    padding: 28px 12px 36px;
  }
}

/* 窄侧栏仅在中等宽度桌面生效；≤960 由下一断点改为单列 + sticky */
@media screen and (max-width: 1100px) and (min-width: 961px) {
  .md-detail-catalog-layout {
    grid-template-columns: minmax(0, 80px) minmax(0, 1fr);
  }

  .md-html-sidebar {
    max-width: 72px;
  }
}

@media screen and (max-width: 960px) {
  .md-detail-catalog-layout--two {
    grid-template-columns: 1fr;
  }

  .md-detail-sidebar-column {
    max-width: none;
    width: 100%;
  }

  .md-html-sidebar {
    position: sticky;
    top: 0;
    z-index: 20;
    max-width: none;
    width: 100%;
    max-height: none;
    overflow-x: hidden;
    overflow-y: visible;
    box-shadow: 0 4px 20px rgba(23, 92, 196, 0.06);
  }
}

/* 专题介绍富文本：限制宽度，避免大图把布局顶偏 */
.major-ztjs-html {
  padding: 5px 0;
  line-height: 1.75;
  font-size: 18px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.major-ztjs-html :deep(img),
.major-ztjs-html :deep(video),
.major-ztjs-html :deep(svg) {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px auto;
  box-sizing: border-box;
}

.major-ztjs-html :deep(table) {
  max-width: 100%;
  display: block;
  overflow-x: auto;
}

.major-ztjs-html :deep(p),
.major-ztjs-html :deep(div) {
  max-width: 100%;
}

.major-solution-list {
  padding: 0 0 28px;
  max-width: 100%;
  box-sizing: border-box;
}

.major-solution-attach-link {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  color: #175cc4;
  text-decoration: none;
}

.major-solution-attach-link:hover {
  text-decoration: underline;
  color: #0d4a9e;
}

.major-solution-attach-link:focus-visible {
  outline: 2px solid #175cc4;
  outline-offset: 3px;
  border-radius: 4px;
}

.major-solution-attach-link--h5 {
  font-size: 15px;
}

.major-solution-list--h5 {
  padding: 0;
}

.major-solution-row {
  padding: 18px clamp(16px, 2vw, 24px);
  margin-bottom: 16px;
  background: #fff;
  border: none;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 6px 9px 3px rgb(123 123 123 / 21%);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.major-solution-row:hover {
  box-shadow:
    6px 9px 3px rgb(123 123 123 / 21%),
    rgba(0, 0, 0, 0.07) 0 0 9px 6px;
}

.major-solution-list--h5 .major-solution-row {
  padding: 12px 10px;
  margin-bottom: 10px;
}

/* H5 培养方案单条：与同一面板内「课程资源」下正文区一致，不叠一层 major-solution-row */
.h5-md-solution-panel {
  padding-top: 8px;
  box-sizing: border-box;
}

.h5-md-solution-panel .major-solution-attach-link + .h5-md-solution-panel__html,
.h5-md-solution-panel .md-solution-pdf-viewer + .h5-md-solution-panel__html {
  margin-top: 12px;
}

.major-solution-row:last-child {
  margin-bottom: 0;
}

.major-solution-row__title {
  font-size: 18px;
  font-weight: 700;
  color: #303030;
  line-height: 1.45;
  margin-bottom: 8px;
}

.major-solution-row__title--link {
  display: inline-block;
  color: #175cc4;
  text-decoration: none;
  cursor: pointer;
}

.major-solution-row__title--link:hover {
  text-decoration: underline;
  color: #0d4a9e;
}

.major-solution-row__title--link:focus-visible {
  outline: 2px solid #175cc4;
  outline-offset: 3px;
  border-radius: 4px;
}

.major-solution-list--h5 .major-solution-row__title {
  font-size: 16px;
  margin-bottom: 6px;
}

.major-solution-row__content {
  margin-top: 4px;
}

.major-solution-row__content.major-ztjs-html {
  font-size: 16px;
}

.major-solution-list--h5 .major-solution-row__content {
  font-size: 14px;
}

.md-course-tabs--h5 {
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 0;
  padding-bottom: 2px;
  margin-bottom: 14px;
}

.md-course-tabs--h5::-webkit-scrollbar {
  height: 4px;
}

.md-course-tabs--h5::-webkit-scrollbar-thumb {
  background: rgba(20, 86, 200, 0.35);
  border-radius: 4px;
}

.md-course-tabs--h5 .md-course-tab {
  flex: 0 0 auto;
  white-space: nowrap;
  padding: 8px 14px;
  font-size: 13px;
}

.md-course-tab-panel.major-topic-tab-panel--h5 {
  min-height: min(360px, 45vh);
}

.major-detail-h5 {
  min-height: 100vh;
  background: #f6f6f6;
}

.h5-md-segment {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 4px 2px 16px;
  margin: 0 0 12px;
}

.h5-md-segment__btn {
  flex: 0 0 auto;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  background: #fff;
  border: 1px solid #e5eaf5;
  border-radius: 999px;
  cursor: pointer;
  font-family: inherit;
}

.h5-md-segment__btn--active {
  color: #fff;
  background: linear-gradient(135deg, #1456c8, #3b8beb);
  border-color: transparent;
}

.h5-md-panel {
  background: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px clamp(12px, 3.5vw, 18px) 18px;
  margin-bottom: 16px;
  box-shadow: 6px 9px 3px rgb(123 123 123 / 21%);
}

.h5-md-panel__head {
  margin-bottom: 12px;
}

.h5-md-panel__tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  color: #1a3a6e;
  background: #eef4ff;
  border: 1px solid #c5d9f5;
  border-radius: 12px;
  padding: 2px 10px;
  margin-bottom: 8px;
}

.h5-md-panel__title {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.35;
}

.h5-md-panel__title--solo {
  margin: 0;
}

.h5-md-panel__head:has(.h5-md-panel__title--solo) {
  margin-bottom: 14px;
}

.h5-md-panel__card {
  padding: 4px 0 0;
}

.h5-md-panel .h5-ztjs-html :deep(table) {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin: 10px 0;
}

.h5-md-panel .h5-ztjs-html :deep(th),
.h5-md-panel .h5-ztjs-html :deep(td) {
  padding: 8px 10px;
  border: 1px solid #e8edf5;
}

.h5-md-panel .h5-ztjs-html :deep(th) {
  background: #f0f5ff;
  color: #1a3a6e;
  font-weight: 600;
}

.h5-topbar {
  padding: 12px clamp(14px, 4vw, 20px) 4px;
  background: #fff;
}

.h5-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 4px;
  border: none;
  background: transparent;
  color: #175cc4;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.h5-carousel-wrap {
  background: #fff;
}

.h5-swipe {
  width: 100%;
}

.h5-title-block {
  padding: 14px clamp(16px, 4vw, 22px) 16px;
  background: #fff;
  border-bottom: 1px solid rgba(23, 92, 196, 0.1);
  text-align: center;
}

.h5-page-title {
  margin: 0 auto;
  font-size: 20px;
  font-weight: 800;
  color: #303133;
  line-height: 1.4;
  text-align: center;
  width: 100%;
  max-width: 100%;
}

.h5-page-meta {
  margin: 10px 0 0;
  font-size: 13px;
  color: #606266;
  text-align: center;
  line-height: 1.5;
}

.h5-detail-body {
  min-height: 120px;
  padding: 16px clamp(14px, 4.5vw, 22px) 28px;
  box-sizing: border-box;
}

.h5-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.h5-ztjs-html {
  font-size: 15px;
  line-height: 1.75;
  color: #333;
}
</style>

<style scoped>
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
